module.exports = __webpack_public_path__ + "img/circle.65f36ea1.png";